"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var Container = (0, material_1.styled)('div', { name: 'Container' })({
    display: 'flex',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
});
var FirstName = (0, material_1.styled)('span', { name: 'FirstName' })(function (_a) {
    var truncate = _a.truncate;
    return ({
        flex: "0 ".concat(truncate ? '1' : '0', " auto"),
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    });
});
var Name = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    if (!children && typeof children !== 'string') {
        throw new Error('You must pass in the name as a string <Name>first last</Name>');
    }
    var _b = __read(children.split(' '), 2), firstName = _b[0], lastName = _b[1];
    var ref = react_1.default.useRef(null);
    var _c = __read(react_1.default.useState({ truncate: false }), 2), state = _c[0], setState = _c[1];
    react_1.default.useEffect(function () {
        var onResize = function () {
            var el = ref === null || ref === void 0 ? void 0 : ref.current;
            if (el) {
                if (el.offsetWidth < el.scrollWidth) {
                    setState({ truncate: true, maxWidth: el.scrollWidth });
                }
                else if (state.truncate && el.offsetWidth > state.maxWidth) {
                    setState({ truncate: false });
                }
            }
        };
        onResize();
        window.addEventListener('resize', onResize);
        return function () { return window.removeEventListener('resize', onResize); };
    }, [state, ref]);
    return (react_1.default.createElement(Container, __assign({ ref: ref }, props),
        react_1.default.createElement(FirstName, { truncate: state.truncate }, firstName),
        lastName && (react_1.default.createElement(react_1.default.Fragment, null,
            "\u00A0",
            react_1.default.createElement("span", null, state.truncate ? "".concat(lastName[0], ".") : lastName)))));
};
exports.default = Name;
//# sourceMappingURL=index.js.map